import {useCallback} from 'react'

import {setUserProperty} from '../actions'
import type {UserProperty} from '../utils/userProperties'

import {useAppDispatch} from './react-redux'

export function useSetUserProperty() {
  const dispatch = useAppDispatch()
  return useCallback(
    (name: UserProperty, value: string) => dispatch(setUserProperty(name, value)),
    [dispatch],
  )
}
